import styled from '@emotion/styled';
import { Breakpoint, isExpanded, isMedium } from '../../../types';
import { shouldForwardProps } from '../../../utils';
import { Row } from '../../../styles';

type HeaderContainerProps = {
    breakpoint: Breakpoint;
    hasBackground?: boolean;
};

const HeaderContainer = styled(
    Row,
    shouldForwardProps
)<HeaderContainerProps>(({ breakpoint, theme }) => ({
    alignItems: 'center',
    position: 'sticky',
    height: '80px',
    width: '100%',
    top: 0,
    paddingRight: theme.spacing(isExpanded(breakpoint) ? 3 : 2),
    paddingLeft: isExpanded(breakpoint)
        ? 0 // Expanded
        : isMedium(breakpoint)
          ? theme.spacing(3) // Medium
          : theme.spacing(2), // Compact
    zIndex: theme.zIndex.mobileStepper,
    backgroundColor: theme.colors.surface,
    borderBottom: `1px solid ${theme.colors.primaryContainerDark}`
}));

export { HeaderContainer };
